import { RotateCcwIcon } from 'lucide-react'

import type { CellContext } from '@/components/ui/table/types'
import {
  type Document,
  type DocumentStatus,
  DocumentStatusBadge,
  ProcessDocumentsButton,
} from '@/modules/documents'
import { hasDocumentFailed } from '@/modules/documents/status'

export const StatusCell = (cell: CellContext<Document, string>) => {
  const document = cell.row.original

  return (
    <div className="flex gap-1">
      <DocumentStatusBadge status={cell.getValue() as DocumentStatus} />{' '}
      {hasDocumentFailed(document) && (
        <div className="flex items-center text-xs text-gray-500">
          <ProcessDocumentsButton
            table={cell.table}
            documentsToProcess={[document]}
            theme="ghost"
            size="xs"
            icon={RotateCcwIcon}
            title="Retry document"
            isIcon
          />
        </div>
      )}
    </div>
  )
}
